import * as actions from './actions'

export const tryToRecover = [
  actions.tryToRecover,
]
